import React, { Component } from 'react';

import apiService from '../lib/apiService';
import Loading from '../lib/Loading';
import AppLayout from '../lib/AppLayout';
import Failed from '../lib/Failed';
import Success from '../lib/Success';

export default class AccountActivate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      success: false
    };

    apiService('/activate/', 'POST', props.query)
    .then((response) => response.ok ? {ok: true} : response.json())
    .then((response) => {
      const success =
        response.ok || (
          response.detail.token &&
          // following error means that this account was already activated
          // and we just show success message again in this case
          (
            response.detail.token[0].message === 'Stale token for given user.' ||
            response.detail.token[0].message === 'Invalid token for given user.'
          )
        );

      setTimeout(() => {
        this.setState((state) => ({
          isLoading: false,
          success
        }))
      }, 600);
    })
  }
  render() {
    const {isLoading, success} = this.state;

    if (isLoading) {
      return <Loading />
    }

    return <AppLayout>{
      success
        ? <Success
          key='v'
          title='Account Verified'
          message={
            'Your email has been successfully verified. ' +
            'Please open the app now on your phone to proceed.'
          }
        />
        : <Failed
          key='f'
          title={
            'Verification failed'
          }
          message={
            'Please check the link we sent you and try again.' +
            'If you still can’t verify your account, contact support.'
          }
        />
    }</AppLayout>
  }
}



// WEBPACK FOOTER //
// ./src/views/AccountActivate.js